import { Box, Typography } from "@mui/material";
import { isObjectEmpty } from "data/functions";
import React from "react";
import { useTimer } from "react-timer-hook";

export function Timer(props) {
  // const [select, setSelect] = React.useState(expiryTimestamp || 10);
  // const [remVisible, setRemVisible] = React.useState(true);
  const [expiryTimestamp, setExpiryTimestamp] = React.useState(() => {
    const time = new Date();
    time.setSeconds(time.getSeconds() + 60);
    return time;
  });

  const {
    days,
    hours,
    minutes,
    // isRunning,
    // start,
    // pause,
    // resume,
    restart,
    seconds,
    totalSeconds,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => {
      props?.setRemainingTime(0);
    },
  });

  React.useEffect(() => {
    if (
      !isObjectEmpty(props?.expiryTimestamp) &&
      Object.prototype.toString.call(props?.expiryTimestamp) === "[object Date]"
    ) {
      const time = props?.expiryTimestamp;
      setExpiryTimestamp(time);
      restart(time);
      // else start();
    }
  }, [props?.expiryTimestamp]);

  React.useEffect(() => {
    if (totalSeconds > 0) props?.setRemainingTime(totalSeconds);
  }, [totalSeconds]);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {(minutes > 0 || seconds > 0) && (
        <React.Fragment>
          {props?.variant === "code" && (
            <Typography sx={{ textAlign: "center" }} variant="body2">
              Повторная отправка возможна
              <br /> через {minutes ? minutes + " мин." : ""} {seconds} сек.
            </Typography>
          )}
          {props?.variant === "qr" && (
            <Typography sx={{ textAlign: "center" }} variant="body1">
              Обновится через {minutes || seconds ? minutes + 1 + " мин. " : ""}
            </Typography>
          )}
          {props?.variant === "url" && (
            <Typography sx={{ textAlign: "center" }} variant="body2">
              До окончания срока действия сообщения
              <br /> осталось {days ? days + " д. " : ""}
              {hours ? hours + " ч. " : ""}
              {minutes ? minutes + " мин. " : ""}
              {seconds} сек.
            </Typography>
          )}
        </React.Fragment>
      )}
      {!totalSeconds && props?.variant === "url" && (
        <Typography color="darkred" variant="body2">
          Срок действия сообщения истек.
        </Typography>
      )}
    </Box>
  );
}
